import React from 'react';
import { Link } from 'react-router-dom';

function Blog() {
  // Sample blog posts - you can replace this with API calls later
  const allPosts = [
    {
      id: 1,
      title: 'Building Better Sleep Habits',
      excerpt: 'Learn how to improve your sleep quality with these practical tips and create a bedtime routine that actually works.',
      date: 'January 5, 2026',
      category: 'Mental Health',
      slug: 'building-better-sleep-habits'
    },
    {
      id: 2,
      title: '5 Quick Breakfast Recipes Under 10 Minutes',
      excerpt: 'Start your day right with these simple, nutritious breakfast recipes that are perfect for busy mornings.',
      date: 'January 3, 2026',
      category: 'Recipes',
      slug: '5-quick-breakfast-recipes'
    },
    {
      id: 3,
      title: 'Getting Started with Home Brewing',
      excerpt: 'Discover the art of brewing your own beer at home. A complete beginner\'s guide to this rewarding hobby.',
      date: 'December 28, 2025',
      category: 'Hobbies',
      slug: 'getting-started-home-brewing'
    },
    {
      id: 4,
      title: 'The Ultimate Guide to Laundry',
      excerpt: 'Master the basics of laundry with our comprehensive guide covering everything from sorting to stain removal.',
      date: 'December 20, 2025',
      category: 'Life Tips',
      slug: 'ultimate-guide-to-laundry'
    },
    {
      id: 5,
      title: 'Managing Stress in Your Daily Life',
      excerpt: 'Practical strategies to identify, manage, and reduce stress in your everyday routine.',
      date: 'December 15, 2025',
      category: 'Mental Health',
      slug: 'managing-stress-daily-life'
    },
    {
      id: 6,
      title: 'One-Pot Pasta Recipes for Easy Cleanup',
      excerpt: 'Delicious pasta dishes that cook in one pot, making cleanup a breeze. Perfect for weeknight dinners.',
      date: 'December 10, 2025',
      category: 'Recipes',
      slug: 'one-pot-pasta-recipes'
    },
    {
      id: 7,
      title: 'Creating a Morning Routine That Sticks',
      excerpt: 'Build a sustainable morning routine that sets you up for success throughout the day.',
      date: 'December 5, 2025',
      category: 'Mental Health',
      slug: 'creating-morning-routine'
    },
    {
      id: 8,
      title: 'Photography Basics for Beginners',
      excerpt: 'Start your photography journey with these essential tips and techniques for capturing great shots.',
      date: 'November 28, 2025',
      category: 'Hobbies',
      slug: 'photography-basics-beginners'
    }
  ];

  return (
    <div className="archive-container">
      <div className="archive-header">
        <h1 className="archive-title">All Articles</h1>
        <p className="archive-description">Browse our complete collection of bachelor living guides and tips</p>
      </div>

      <div className="content-wrapper">
        <div className="posts-grid">
          {allPosts.map((post) => (
            <article key={post.id} className="post-card">
              <div className="post-thumbnail-link">
                <div className="post-thumbnail" style={{
                  background: '#E8DFD4',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '3rem'
                }}>
                  {post.category === 'Mental Health' && '🧠'}
                  {post.category === 'Recipes' && '🍳'}
                  {post.category === 'Hobbies' && '🎯'}
                  {post.category === 'Life Tips' && '💡'}
                </div>
              </div>

              <div className="post-content">
                <h3 className="post-title">
                  <Link to={`/blog/${post.slug}`}>{post.title}</Link>
                </h3>

                <div className="post-excerpt">
                  {post.excerpt}
                </div>

                <div className="post-meta">
                  <span>📅 {post.date}</span>
                  <span>📂 {post.category}</span>
                </div>

                <Link to={`/blog/${post.slug}`} className="read-more">Read More &rarr;</Link>
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Blog;
